export default {
  setHasMlopsActive: function setHasMlopsActive(state, data) {
    state.has_mlops_active = data;
  }
};